import { isString, get, omitBy, isNil } from 'lodash-es';
import moment from 'moment';
import type { CoreTypes } from '../../core';
import type { Person } from '../types/persons';
import { getDivisionId, hasDivisionId, type DivisionScope } from './common';

const SexMap: Record<NonNullable<CoreTypes.Deep.Person['sex']>, Person['sex']> = { Man: 'Man', Woman: 'Kvinna' };
const TypeMap: Record<
  NonNullable<
    CoreTypes.Deep.Person['phoneNumbers']
  >[0]['type'],
  NonNullable<
    Person['phoneNumbers']
  >[0]['type']
> = {
  private:      'Privat',
  organization: 'Arbete övrigt'
};

/**
 * @deprecated This is only used for SCS. can be removed when scs use v2
 */
export default (
  persons: Extract<CoreTypes.Mixed.Person, { id: string }>[],
  domain?: DivisionScope
): Person[] => {
  if (!Array.isArray(persons))
    throw new Error('(SS12000::To::Persons) Person input is not of array type', { cause: 'invalid_input' });

  if (!persons.every((person) => isString(person) || isString(get(person, 'id'))))
    throw new Error('(SS12000::To::Persons) Some persons are missing "id" values', { cause: 'invalid_input' });

  if (!domain && !persons.every((person) => !isString(person) && hasDivisionId(person)))
    throw new Error('(SS12000::To::Persons) Some top layer persons are missing division values', { cause: 'invalid_input' });

  return persons.map((person) => ({
    id: `${ getDivisionId(person, domain) }.${ isString(person) ? person : person.id }`,
    ...!isString(person) && {
      meta: {
        created:  moment(person.createdAt).toISOString(),
        modified: moment(person.updatedAt).toISOString()
      },
      sex: person.sex ? get(SexMap, person.sex, 'Okänt') : 'Okänt',
      ...omitBy({
        foreignId:    person.ids,
        displayName:  person.displayName,
        givenName:    person.firstName,
        familyName:   person.lastName,
        ...person.SSN?.value && { civicNo: person.SSN },
        emails:       person.emails,
        phoneNumbers: person.phoneNumbers
      }, isNil)
    }
  }));
};